export function usePropsOfType(props, type) {
    const filteredItems = Object.keys(props)
        .filter(key => { var _a; return ((_a = props[key]) === null || _a === void 0 ? void 0 : _a.type) === type; })
        .reduce((mergedList, currentKey) => {
        var _a, _b;
        const contentItem = props[currentKey];
        const item = [];
        if (((_a = contentItem.value) === null || _a === void 0 ? void 0 : _a.__typename) === 'StringValue') {
            item.push((_b = contentItem.value) === null || _b === void 0 ? void 0 : _b.value);
        }
        else {
            contentItem.value && item.push(contentItem.value);
        }
        return mergedList.concat(item);
    }, []);
    return { filteredItems };
}
//# sourceMappingURL=usePropsOfType.js.map